package org.multipaz.utopia.generated

/**
 * Generated strings for language: ja
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_ja = mapOf(
    "boarding_pass_attribute_departure_time" to "出発時刻",
    "boarding_pass_attribute_flight_number" to "便名",
    "boarding_pass_attribute_passenger_name" to "搭乗者氏名",
    "boarding_pass_attribute_seat_number" to "座席番号",
    "boarding_pass_description_departure_time" to "出発日時",
    "boarding_pass_description_flight_number" to "便名",
    "boarding_pass_description_passenger_name" to "mDL保持者の姓、または主要な識別子。",
    "boarding_pass_description_seat_number" to "座席番号",
    "cor_attribute_administrative_number" to "管理番号",
    "cor_attribute_date_of_arrival" to "到着日",
    "cor_attribute_date_of_birth" to "生年月日",
    "cor_attribute_date_of_expiry" to "有効期限",
    "cor_attribute_date_of_issue" to "発行日",
    "cor_attribute_document_number" to "書類番号",
    "cor_attribute_family_name" to "姓",
    "cor_attribute_gender" to "性別",
    "cor_attribute_given_names" to "名",
    "cor_attribute_issuing_authority" to "発行機関",
    "cor_attribute_issuing_country" to "発行国",
    "cor_attribute_issuing_jurisdiction" to "発行管轄",
    "cor_attribute_nationality" to "国籍",
    "cor_attribute_older_than_18" to "18歳以上",
    "cor_attribute_older_than_21" to "21歳以上",
    "cor_attribute_place_of_birth" to "出生地",
    "cor_attribute_resident_address" to "居住地住所",
    "cor_attribute_resident_city" to "居住都市",
    "cor_attribute_resident_country" to "居住国",
    "cor_attribute_resident_house_number" to "居住地番地",
    "cor_attribute_resident_postal_code" to "居住地郵便番号",
    "cor_attribute_resident_state" to "居住州",
    "cor_attribute_resident_street" to "居住地通り",
    "cor_description_administrative_number" to "監査管理またはその他の目的のためにCORプロバイダーによって割り当てられる番号。",
    "cor_description_date_of_arrival" to "COR保有者がEUに到着した日（日、月、年）",
    "cor_description_date_of_birth" to "COR保有者の生年月日（日、月、年）。不明な場合はおおよその生年月日。",
    "cor_description_date_of_expiry" to "CORの有効期限日（および時刻）。",
    "cor_description_date_of_issue" to "CORの発行日（および時刻）。",
    "cor_description_document_number" to "CORプロバイダーによって割り当てられるCORの番号。",
    "cor_description_family_name" to "COR保有者の現在の姓、名字、または主要な識別子",
    "cor_description_gender" to "COR保持者の性別。",
    "cor_description_given_names" to "COR保有者の現在の名、その他の名前、または副次的識別子",
    "cor_description_issuing_authority" to "このCORインスタンスを発行した行政機関の名称、またはCORを発行する権限を持つ個別の機関がない場合は、当該加盟国のISO 3166 Alpha-2国コード。",
    "cor_description_issuing_country" to "発行機関の国または地域のISO 3166-1で定義されているAlpha-2国コード。",
    "cor_description_issuing_jurisdiction" to "CORを発行した管轄区域の国細分コード（ISO 3166-2:2020、第8項で定義）。コードの最初の部分はissuing_countryの値と同じでなければなりません。",
    "cor_description_nationality" to "ユーザーの国籍を表すISO 3166-1準拠のアルファベット2文字の国コード。",
    "cor_description_older_than_18" to "18歳以上ですか？",
    "cor_description_older_than_21" to "21歳以上ですか？",
    "cor_description_place_of_birth" to "COR保持者の出生地。",
    "cor_description_resident_address" to "COR保有者が現在居住し、または連絡が取れる場所の完全な住所（番地、市町村など）",
    "cor_description_resident_city" to "COR保持者が現在居住している市。",
    "cor_description_resident_country" to "ユーザーが現在居住している国（ISO 3166-1で指定されているAlpha-2国コード）",
    "cor_description_resident_house_number" to "ユーザーが現在居住している番地（接頭辞や接尾辞を含む）。",
    "cor_description_resident_postal_code" to "COR保持者が現在居住している場所の郵便番号。",
    "cor_description_resident_state" to "ユーザーが現在居住している州、都道府県、地区、または地方。",
    "cor_description_resident_street" to "ユーザーが現在居住している通りの名称。",
    "cor_request_age_over_18" to "18歳以上",
    "cor_request_all_data_elements" to "全データ項目",
    "cor_request_mandatory_data_elements" to "必須データ項目",
    "document_display_name_boarding_pass" to "搭乗券",
    "document_display_name_certificate_of_residency" to "居住証明書",
    "document_display_name_german_personal_id" to "ドイツ身分証明書",
    "document_display_name_loyalty_card" to "ポイントカード",
    "document_display_name_movie_ticket" to "映画チケット",
    "document_display_name_naturalization_certificate" to "帰化証明書",
    "document_display_name_payment_card" to "支払いカード",
    "german_id_attribute_administrative_number" to "管理番号",
    "german_id_attribute_age_in_years" to "年齢",
    "german_id_attribute_city_of_birth" to "出生都市",
    "german_id_attribute_country_of_birth" to "出生国",
    "german_id_attribute_date_of_birth" to "生年月日",
    "german_id_attribute_date_of_expiry" to "有効期限",
    "german_id_attribute_date_of_issue" to "発行日",
    "german_id_attribute_document_number" to "文書番号",
    "german_id_attribute_family_name" to "姓",
    "german_id_attribute_family_name_at_birth" to "出生時の姓",
    "german_id_attribute_gender" to "性別",
    "german_id_attribute_given_names" to "名",
    "german_id_attribute_issuing_authority" to "発行機関",
    "german_id_attribute_issuing_country" to "発行国",
    "german_id_attribute_issuing_jurisdiction" to "発行管轄",
    "german_id_attribute_nationality" to "国籍",
    "german_id_attribute_older_than_12" to "12歳以上",
    "german_id_attribute_older_than_14" to "14歳以上",
    "german_id_attribute_older_than_16" to "16歳以上",
    "german_id_attribute_older_than_18" to "18歳以上",
    "german_id_attribute_older_than_21" to "21歳以上",
    "german_id_attribute_older_than_65" to "65歳以上",
    "german_id_attribute_place_of_birth" to "出生地",
    "german_id_attribute_resident_address" to "居住住所",
    "german_id_attribute_resident_city" to "居住都市",
    "german_id_attribute_resident_country" to "居住国",
    "german_id_attribute_resident_postal_code" to "居住地郵便番号",
    "german_id_attribute_state_of_birth" to "出生州",
    "german_id_attribute_year_of_birth" to "生年",
    "german_id_description_administrative_number" to "監査管理またはその他の目的でPIDプロバイダーによって割り当てられた番号。",
    "german_id_description_age_in_years" to "PID所有者の年齢（年単位）",
    "german_id_description_city_of_birth" to "PIDユーザーが生まれた市町村、または村",
    "german_id_description_country_of_birth" to "PIDユーザーの出生国（ISO 3166-1で指定されたアルファ-2国コード）",
    "german_id_description_date_of_birth" to "PID所有者の生年月日。不明な場合は概算の生年月日。",
    "german_id_description_date_of_expiry" to "PIDが期限切れになる日付（および時刻）",
    "german_id_description_date_of_issue" to "PIDが発行された日付（および時刻）",
    "german_id_description_document_number" to "PIDプロバイダーによって割り当てられた、PIDの番号。",
    "german_id_description_family_name" to "現在の姓、名字、またはPID所有者の主要識別子",
    "german_id_description_family_name_at_birth" to "出生時の姓（旧姓）、またはPID保持者の主要識別子",
    "german_id_description_gender" to "PID保持者の性別",
    "german_id_description_given_names" to "現在の名、その他の名、またはPID所有者の副次的識別子",
    "german_id_description_issuing_authority" to "このPIDインスタンスを発行した行政機関の名称、またはPID発行を認可された個別の機関がない場合は、該当加盟国のISO 3166 Alpha-2国コード",
    "german_id_description_issuing_country" to "ISO 3166-1で定義されている、発行当局の国または地域のAlpha-2国コード。",
    "german_id_description_issuing_jurisdiction" to "ISO 3166-2:2020、Clause 8で定義されている、PIDを発行した管轄区域の国細分コード。コードの最初の部分は、発行国と同じ値である必要があります。",
    "german_id_description_nationality" to "PIDユーザーの国籍を示す、ISO 3166-1で指定されたAlpha-2国コードのリスト",
    "german_id_description_older_than_12" to "12歳以上ですか？",
    "german_id_description_older_than_14" to "14歳以上ですか？",
    "german_id_description_older_than_16" to "16歳以上ですか？",
    "german_id_description_older_than_18" to "18歳以上ですか？",
    "german_id_description_older_than_21" to "21歳以上ですか？",
    "german_id_description_older_than_65" to "65歳以上ですか？",
    "german_id_description_place_of_birth" to "PID保持者の出生国と市町村、または州/都道府県",
    "german_id_description_resident_address" to "PID保持者が現在居住し、または連絡が取れる場所の完全な住所（番地、市町村など）",
    "german_id_description_resident_city" to "PID保持者が現在居住している市",
    "german_id_description_resident_country" to "PIDユーザーが現在居住している国（ISO 3166-1で指定されたAlpha-2国コード）",
    "german_id_description_resident_postal_code" to "PID保持者が現在居住している場所の郵便番号",
    "german_id_description_state_of_birth" to "PIDユーザーの出生州、省、地区、または地方",
    "german_id_description_year_of_birth" to "PID所有者の生年",
    "german_id_request_age_over_18" to "18歳以上",
    "german_id_request_all_data_elements" to "すべてのデータ要素",
    "german_id_request_mandatory_data_elements" to "必須データ要素",
    "loyalty_attribute_date_of_expiry" to "有効期限",
    "loyalty_attribute_date_of_issue" to "発行日",
    "loyalty_attribute_family_name" to "姓",
    "loyalty_attribute_given_names" to "名",
    "loyalty_attribute_membership_id" to "会員ID",
    "loyalty_attribute_photo_of_holder" to "保持者の写真",
    "loyalty_attribute_tier" to "ランク",
    "loyalty_description_date_of_expiry" to "有効期限",
    "loyalty_description_date_of_issue" to "発行日",
    "loyalty_description_family_name" to "書類所有者の姓、または主要識別子",
    "loyalty_description_given_names" to "書類所有者の名、または副次的な識別子",
    "loyalty_description_membership_id" to "ロイヤリティID保持者の個人識別子。",
    "loyalty_description_photo_of_holder" to "書類所有者の顔写真。",
    "loyalty_description_tier" to "会員ランク（ベーシック、シルバー、ゴールド、プラチナ、エリート）",
    "loyalty_request_all_data_elements" to "全データ項目",
    "loyalty_request_mandatory_data_elements" to "必須データ項目",
    "movie_ticket_attribute_age_rating_code" to "年齢区分コード",
    "movie_ticket_attribute_cinema_theater" to "映画館",
    "movie_ticket_attribute_date_and_time_of_show" to "上映日時",
    "movie_ticket_attribute_movie_poster" to "映画ポスター",
    "movie_ticket_attribute_movie_title" to "作品名",
    "movie_ticket_attribute_parking" to "駐車場",
    "movie_ticket_attribute_seat" to "座席",
    "movie_ticket_attribute_theater" to "劇場",
    "movie_ticket_attribute_ticket_number" to "チケット番号",
    "movie_ticket_description_age_rating_code" to "映画の年齢制限コード",
    "movie_ticket_description_cinema_theater" to "入場する映画館名、および/またはその住所/場所。",
    "movie_ticket_description_date_and_time_of_show" to "上映開始日時",
    "movie_ticket_description_movie_poster" to "映画ポスター",
    "movie_ticket_description_movie_title" to "映画の名称、タイトル、およびその他の上映識別情報。",
    "movie_ticket_description_parking" to "駐車料金前払い",
    "movie_ticket_description_seat" to "座席番号",
    "movie_ticket_description_theater" to "劇場名または番号",
    "movie_ticket_description_ticket_number" to "購入時に発行されるチケットの識別/参照番号。",
    "movie_ticket_request_all_data_elements" to "すべてのデータ要素",
    "movie_ticket_request_prepaid_parking" to "事前決済駐車場",
    "movie_ticket_request_ticket_number" to "チケット番号",
    "naturalization_attribute_date_of_birth" to "生年月日",
    "naturalization_attribute_date_of_naturalization" to "帰化年月日",
    "naturalization_attribute_family_name" to "姓",
    "naturalization_attribute_given_names" to "名",
    "naturalization_description_date_of_birth" to "帰化申請者の生年月日。不明な場合はおおよその生年月日",
    "naturalization_description_date_of_naturalization" to "その人が帰化した日付（時刻を含む場合あり）",
    "naturalization_description_family_name" to "帰化申請者の現在の姓、または主な識別情報",
    "naturalization_description_given_names" to "帰化申請者の現在の名、その他の名前、または補助的な識別情報",
    "naturalization_request_all_data_elements" to "すべてのデータ要素",
    "payment_attribute_expiry_date" to "有効期限",
    "payment_attribute_holder_name" to "名義人名",
    "payment_attribute_issue_date" to "発行日",
    "payment_attribute_issuer_name" to "発行者名",
    "payment_attribute_masked_account_reference" to "マスク済みアカウント参照",
    "payment_attribute_payment_instrument_id" to "支払い手段ID",
    "payment_description_expiry_date" to "この認証情報の有効期限です。",
    "payment_description_holder_name" to "決済口座名義。",
    "payment_description_issue_date" to "この認証情報の発行日です。",
    "payment_description_issuer_name" to "読みやすい発行元名です。",
    "payment_description_masked_account_reference" to "マスクされたアカウント参照 (例: PAN下4桁)。",
    "payment_description_payment_instrument_id" to "トークン化された決済手段識別子。",
    "payment_request_payment_sca_all" to "決済SCA (全てのデータ要素)",
    "payment_request_payment_sca_minimal" to "決済SCA (最小限)",
    "payment_request_payment_sca_transaction" to "決済トランザクションでのSCA決済"
)
